import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminSolicitudesCatalogoPage } from "@/features/admin-solicitudes-catalogo/components/AdminSolicitudesCatalogoPage";
import { solicitudesCatalogoAdminQueryOptions } from "@/features/admin-solicitudes-catalogo/hooks/use-solicitudes-catalogo-admin";

/**
 * Ruta `/admin/solicitudes-catalogo` · bandeja de peticiones de alta de
 * elementos de catálogo (P38).
 */
export const Route = createFileRoute("/_authed-tw/admin/solicitudes-catalogo")({
  // Precarga la primera página del filtro inicial de la página (Pendiente).
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(
      solicitudesCatalogoAdminQueryOptions({ estado: "Pendiente", page: 1, pageSize: 15 }),
    ),
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminSolicitudesCatalogo]}>
      <AdminSolicitudesCatalogoPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
